import { Injectable } from '@angular/core';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { enduserInterface } from '../../interfaces/enduser';
import { mspGlobal } from '../../global/mspGlobal';
import { Observable, map, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';
import { permissionsInterface } from '../../interfaces/customer';

@Injectable({
	providedIn: 'root',
})
export class PermissionService {
	getCustomerPermissions = environment.baseApiUrl + 'customer/customerPermissions';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	initialPermissionLength = 0;

	constructor(
		private ProfileService: ProfileService,
		private mspGlobal: mspGlobal,
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {
		this.initialPermissionLength = Object.keys(mspGlobal.permissions).length;
	}

	initPermissions(): Observable<any> {
		if (Object.keys(this.mspGlobal.permissions).length > this.initialPermissionLength) return of(this.mspGlobal.permissions);

		const userData = this.ProfileService.userData();
		if (userData === undefined) {
			return this.ProfileService.setLocalUser().pipe(
				map(() => {
					return of(this.setPermissions());
				})
			);
		}

		return of(this.setPermissions());
	}

	setPermissions(): any {
		for (const permission of this.ProfileService.userData().permission.split(',')) {
			this.mspGlobal.permissions[permission.toLowerCase()] = true;
		}

		return this.mspGlobal.permissions;
	}

	hasPermission(key?: string): boolean {
		return this.mspGlobal.permissions[key.toLocaleLowerCase()] === true;
	}

	hasPermissions(permissionString?: string): boolean {
		if (!permissionString) return true;

		const permissionOrArray = permissionString.split('|');
		for (const permissionOr of permissionOrArray) {
			const permissionAndArray = permissionOr.split('&');
			let breakI = false;

			for (const permission of permissionAndArray) {
				if (!this.hasPermission(permission)) {
					breakI = true;
					break;
				}
			}

			if (breakI) continue;

			return true;
		}

		return false;
	}

	hasAnyPermission(permissions: string[]): boolean {
		return permissions.some((permission) => this.getPermission(permission));
	}

	getPermission(key?: string): any {
		key = key.toLowerCase();
		if (key && typeof this.mspGlobal.permissions[key] != undefined) return this.mspGlobal.permissions[key];
		return this.mspGlobal.permissions;
	}

	getCustomersPermissionsList(id_customer: string): Observable<string> {
		return this.http.get<string>(this.getCustomerPermissions, {
			headers: this.headers,
			params: { id_customer: id_customer, list: true },
		});
	}

	getCustomersPermissions(): Observable<permissionsInterface[]> {
		return this.http.get<JSON[]>(this.getCustomerPermissions, { headers: this.headers }).pipe(
			map((permissions) => {
				const permission: permissionsInterface[] = [];

				permissions.forEach((element: any) => {
					const permissionItem: permissionsInterface = {
						permission: element.permission,
						allowed: element.allowed,
						customer: element.customer,
					};
					permission.push(permissionItem);
				});

				return permission;
			})
		);
	}
}
